var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "article-container" }, [
    _vm.$route.name === "my-stories-shared" &&
    _vm.$store.getters
      .getPromoteOption("promotedProjects")
      .map(promotion => promotion.project.id)
      .includes(_vm.project.id)
      ? _c(
          "div",
          {
            class: [
              "promoted",
              {
                "small-font":
                  _vm.$i18n.locale !== "EN" && _vm.$i18n.locale !== "JA"
              }
            ],
            on: {
              click: function($event) {
                return _vm.openProject($event)
              }
            }
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.isActivelyPromoted
                    ? _vm.$t("projectPage.featured")
                    : _vm.$t("projectPage.selected")
                ) +
                " "
            )
          ]
        )
      : _vm._e(),
    _c(
      "div",
      {
        class: [
          "card",
          {
            "list-mode":
              ((_vm.isTabletDevice &&
                !_vm.$route.name.includes("search") &&
                !_vm.$route.name.includes("shared")) ||
                _vm.$route.query.view === "LIST" ||
                _vm.forceList) &&
              !_vm.forceGrid
          },
          {
            "not-published":
              _vm.project.currentProjectStep !== "PUBLISHED" &&
              _vm.project.currentProjectStep !== "RO_APPROVAL" &&
              _vm.$route.name !== "singleCaseWithDates" &&
              _vm.$route.name !== "singleCase"
          }
        ],
        on: {
          click: function($event) {
            return _vm.openProject($event)
          }
        }
      },
      [
        _vm.project.currentProjectStep === "PUBLISHED" &&
        _vm.$route.name !== "my-stories-shared" &&
        _vm.hideSave === false
          ? _c("button", { staticClass: "save-button button-save" }, [
              _vm.$store.getters.getSavedProjectIds?.includes(
                Number(_vm.project.id)
              )
                ? _c("img", {
                    staticClass: "button-save",
                    attrs: {
                      src: require("@/common/assets/icons/saved-filled.svg"),
                      alt: "like"
                    }
                  })
                : _c("img", {
                    staticClass: "button-save",
                    attrs: {
                      src: require("@/common/assets/icons/saved.svg"),
                      alt: "like"
                    }
                  })
            ])
          : _vm._e(),
        _c("CardProjectActions", {
          attrs: { project: _vm.project },
          on: { hideProject: _vm.hideProject }
        }),
        _c("div", { staticClass: "card-image-container" }, [
          _vm.project.industryReference &&
          _vm.project.industryReference.industry
            ? _c("div", { staticClass: "card-industry" }, [
                _c("span", { staticClass: "industry" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.project.industryReference.industry.translations.find(
                          translation =>
                            translation.language.name === _vm.$i18n.locale
                        ).name
                      ) +
                      " "
                  )
                ]),
                _vm.project.industryReference.subIndustries?.length > 0
                  ? _c("span", { staticClass: "sub-industry" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.project.industryReference.subIndustries[0].translations.find(
                              translation =>
                                translation.language.name === _vm.$i18n.locale
                            ).name
                          ) +
                          " "
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _c("img", {
            attrs: { src: _vm.getMainImage(), alt: "img" },
            on: { error: _vm.setFallback }
          })
        ]),
        _c("div", { staticClass: "card-data" }, [
          _c("div", { staticClass: "card-content-container" }, [
            _vm.project.translations?.find(
              translation => translation.language.name === _vm.$i18n.locale
            )?.referenceTitle
              ? _c("h5", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.project.translations.find(
                        translation =>
                          translation.language.name === _vm.$i18n.locale
                      ).referenceTitle
                    )
                  }
                })
              : _c("h5", [_vm._v(_vm._s(_vm.$t("projectPage.noTitle")))]),
            _c("div", { staticClass: "card-details" }, [
              _vm.project.management?.datePublish
                ? _c("div", { staticClass: "detail" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/drc/assets/icons/calendar-logo.svg"),
                        alt: "calendar"
                      }
                    }),
                    _c("span", { staticClass: "detail-date" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            `${_vm.$i18n.t(
                              `commonDOCX.${new Intl.DateTimeFormat("en-US", {
                                month: "long"
                              }).format(
                                new Date(_vm.project.management.datePublish)
                              )}`
                            )}`
                          ) +
                          " " +
                          _vm._s(
                            `${new Date(
                              _vm.project.management.datePublish
                            ).getDate()}, ${new Date(
                              _vm.project.management.datePublish
                            ).getFullYear()}`
                          ) +
                          " "
                      )
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "detail" }, [
                _c("img", {
                  attrs: {
                    src: require("@/drc/assets/icons/eye-logo.svg"),
                    alt: "calendar"
                  }
                }),
                _c("span", { staticClass: "detail-views" }, [
                  _vm._v(
                    _vm._s(
                      _vm.project.views
                        ? `${_vm.project.views} ${_vm.$t(
                            "projectPage.aside.views"
                          )}`
                        : `0 ${_vm.$t("projectPage.aside.views")}`
                    )
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "card-language-validations" }, [
            _c("span", { staticClass: "card-language-text" }, [
              _vm._v(_vm._s(_vm.$t("search.validatedIn")))
            ]),
            _c(
              "div",
              { staticClass: "language-validation-container" },
              [
                _vm._l(_vm.validatedLanguages, function(language, index) {
                  return _c("img", {
                    key: index,
                    attrs: {
                      src: require(`@/drc/assets/images/flags/${language}.svg`),
                      alt: "flag"
                    }
                  })
                }),
                _vm.moreLanguages.length > 0
                  ? _c(
                      "div",
                      { staticClass: "language-tooltip" },
                      _vm._l(_vm.languages, function(language, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "flags-container" },
                          [
                            _c("img", {
                              staticClass: "tooltip-flags",
                              attrs: {
                                src: require(`@/drc/assets/images/flags/${language}.svg`),
                                alt: "flag-tooltip"
                              }
                            }),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  `${_vm.LANGUAGE[language.toLowerCase()].name}`
                                )
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.moreLanguages.length > 0
                  ? _c("span", { staticClass: "language-number" }, [
                      _vm._v("+" + _vm._s(`${_vm.moreLanguages.length}`))
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }